import { defineStore } from 'pinia';
import { useUserStore } from '@/entities/user/model/userStore'

export const useRequestStore = defineStore('requests', () => {
  const userStore = useUserStore();

  const send = async (uri: string, { method = 'GET', payload = null, onlyWithAuth = false, noCache = false, customToken = null, signal = null } = {}) => {
    let url = window.APP_CONFIG.API_URL;

    if (!url.endsWith('/')) {
      url += '/'
    }
    if (uri.startsWith('/')) {
      uri = uri.slice(1);
    }

    if (noCache) {
      if (uri.includes('?')) {
        uri += `&t=${Date.now()}`
      } else {
        uri += `?t=${Date.now()}`
      }
    }
    url += `api/${uri}`;

    const options = {
      method,
      signal,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    if (payload instanceof FormData) {
      delete options.headers['Content-Type'];
      options.body = payload;
    } else if (payload instanceof String) {
      options.body = payload;
    } else if (payload instanceof Object && payload !== null) {
      options.body = JSON.stringify(payload);
    }

    if (userStore.isAuth) {
      await userStore.checkToken();
      if (userStore.user !== null) {
        options.headers['Authorization'] = `Bearer ${userStore.user.token}`;
      }
    }

    if (customToken) {
      options.headers['Authorization'] = `Bearer ${customToken}`;
    }

    if (onlyWithAuth && !options.headers['Authorization']) {
      onUnauthorized();
    }

    const request = await fetch(url, options);

    if (request.status === 401) {
      onUnauthorized();
    }

    if (request.status === 403) {
      onForbidden();
    }

    if (!request.ok) {
      const data = await request.json();
      console.error(`Ошибка запроса ${uri}:`, data)
      const error = new Error(data.message ?? 'Ошибка');
      error.code = request.status;
      throw error;
    }

    return await request.json();
  }

  const onUnauthorized = () => {
    // Вероятно устаревший рефреш токен, выкидываем!
    if (userStore.user !== null) {
      userStore.logout()
    }
  }

  const onForbidden = () => {
    userStore.user.isDon = false;
  }

  return {
    send,
  };
})
